import {ComponentRef, Injectable} from '@angular/core';
import {ContextMenuComponent} from '@shared/directives/context-menu/context-menu.component';
import {Subject} from 'rxjs';
import {ContextMenuClick} from '@core/models/common';

@Injectable({
    providedIn: 'root'
})
export class ContextMenuService {

    actionItem = new Subject<ContextMenuClick<unknown>>();
    protected menuInView: ComponentRef<ContextMenuComponent>;

    constructor() {
    }

    set addMenu(item: ComponentRef<ContextMenuComponent>) {
        this.menuInView = item;
    }

    destroy() {
        if (this.menuInView) {
            this.menuInView.destroy();
        }
    }
}
